import { render } from "./LightSpeedScroll.vue?vue&type=template&id=5cc5251f"
import script from "./LightSpeedScroll.vue?vue&type=script&lang=js"
export * from "./LightSpeedScroll.vue?vue&type=script&lang=js"

import "./LightSpeedScroll.vue?vue&type=style&index=0&id=5cc5251f&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__